import React from 'react';
import { WsThreeSixtyWheel } from '../../components/DynamicThreeSixtyWheel/DynamicThreeSixtyWheel';
import logoImage from '../../../../images/three-sixty-image/AvanadeLogo.png';

const WsDynamic360Page = (props: any) => {
  const pathToLogoImage = logoImage;

  return (
    <div>
      <WsThreeSixtyWheel imageLogo={pathToLogoImage} borderColour={'#dc4600'} />
    </div>
  );
};

export { WsDynamic360Page };
